<ng-container *ngIf="results | async as results$; else loading">
  <pie-chart [results]="results$"
             [options]="options"
             (select)="onSelect($event)">
  </pie-chart>


</ng-container>

<ng-template #loading>
  <div style="color:gray; display: block; margin: auto; height: 100%">
    <div style="display: flex;">
      <span class="fa fa-spinner fa-pulse fa-5x" style=" color:gray;"></span>
    </div>
  </div>
</ng-template>
